import React, {useState} from 'react';
import Select from 'react-select';
import {useMutation, useQuery} from '@apollo/client';
import {isActive} from '../Client/utils';
import {QUERY_USER} from '../Client/graphql';
import {QUERY_LESSON_LIST} from '../Lesson/graphql';
import {MUTATION_FORUM_SAVE} from './graphql';

const ForumSave = ({onClose, onSuccess}) => {
  const {user} = useQuery(QUERY_USER).data;
  const [input, setInput] = useState({lessons: []});

  const [save] = useMutation(MUTATION_FORUM_SAVE, {
    onCompleted: data => {
      if (data.forumSave.obj) {
        onClose();
        setInput({lessons: []});
        onSuccess();
      }
    },
  });

  const {lessonList} = useQuery(QUERY_LESSON_LIST).data || {lessonList: []};

  return (
    <div className="bg-white p-3 border-bottom">
      <input
        value={input.name}
        onChange={e => setInput({...input, name: e.target.value})}
        type="text"
        className="form-control"
        placeholder="Заголовок"
      />
      <textarea
        value={input.content}
        onChange={e => setInput({...input, content: e.target.value})}
        className="form-control mt-3"
        placeholder="Текст"
      />
      <Select
        options={lessonList}
        getOptionLabel={op => op.name}
        getOptionValue={op => op.id}
        onChange={op => setInput({...input, lessons: op})}
        value={input.lessons}
        isMulti
        className="mt-3"
        classNamePrefix="white"
        placeholder="Все уроки"
      />
      <div className="row gx-3 mt-3">
        <div className="col-auto">
          <button
            disabled={!isActive(user)}
            onClick={() =>
              save({
                variables: {
                  input: {
                    name: input.name || '',
                    content: input.content || '',
                    tags: input.lessons.map(x => ({lesson: x.id})),
                  },
                },
              })
            }
            className="btn btn-primary"
          >
            Создать
          </button>
        </div>
        <div className="col-auto">
          <button onClick={() => onClose()} className="btn btn-light">
            Отмена
          </button>
        </div>
      </div>
      <div className="alert alert-info mt-3">Автоматический закроется через 30 дней</div>
    </div>
  );
};

export default ForumSave;
